import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events.service';

@Component({
  selector: 'app-porto',
  templateUrl: './porto.component.html',
  styleUrls: ['./porto.component.css']
})
export class PortoComponent implements OnInit {
  
  language: any;
  langChosen: string = 'en';
  selectedIndex: number = 0;
  tournamentPage: number = 1;
  tournamentsViewCount: number = 4;
  loadMore: boolean = false;
  leaderboard: any;
  viewLeaderBoard: boolean = false;
  
  constructor(public eventService: EventsService, public globalService: GlobalService) {
    
    
    // if (localStorage.getItem('language')) {
    //   this.language = require('./lang/' + localStorage.getItem('language') + '.json');
    //   this.langChosen = localStorage.getItem('language');
    // } else {
    this.language = require('./lang/en.json');
    // }
    
  }
  
  ngOnInit() {
  }
  
  languageChange(value) {
    this.langChosen = value;
    this.language = require('./lang/' + value + '.json');
    this.globalService.language = value;
    localStorage.setItem('language', value);
  }
  
  
  loadMoreTournaments() {
    this.tournamentPage++;
    this.loadMore = true;
    this.eventService.getEventTournaments(this.globalService.slug, this.tournamentPage).subscribe(res => {
      this.eventService.eventTournaments.next(Object.assign(this.eventService.eventTournaments.value, res));
      this.loadMore = false;
    })
    
  }
  
  
  getStatus(time, status) {
    let currentTime = new Date().getTime();
    if (currentTime < time)
      return 'Open'
    else {
      if (status != 'Finished')
        return 'In progress'
      else
        return 'Finished'
    }
    
  }
  
  pageChange(event) {
  
  }
}
